import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from '../../../environments/environment';
import { Observable, from, throwError,of } from "rxjs";
import { Login, LoginInput, UserData, Logout } from '../../class/Login/login';
import { map } from 'rxjs/operators';
import { isPlatformBrowser, DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  private apiBaseUrl: string = environment.apiUrl;
  constructor(private http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  sendResetRequest(formData: FormData): Observable<any> {
    return this.http.post(`${this.apiBaseUrl}/api/forgot-password`, formData);
  }

  resetPassword(formData: FormData): Observable<any> {
    return this.http.post(`${this.apiBaseUrl}/api/reset-password`, formData);
  }

  GoLogin(formData: FormData): Observable<LoginInput> {

    if (isPlatformBrowser(this.platformId)) {

      const pec_ipaddress: string = localStorage.getItem('getip') || '0.0.0.0';
      const pec_browser: string = localStorage.getItem('getbrowser') || '-';
      const pec_browser_ver: string = localStorage.getItem('getbrowser_version') || '-';
      const pec_os: string = localStorage.getItem('getostype') || '-';

      formData.append('ipaddress', pec_ipaddress);
      formData.append('browser_ver', pec_browser);
      formData.append('browser', pec_browser_ver);
      formData.append('os', pec_os);

    }


    return this.http.post<LoginInput>(`${this.apiBaseUrl}/api/login/login_verify`, formData)
      .pipe(map(m => <LoginInput>m));
  }


  GetStatus(): Observable<UserData> {

    if (isPlatformBrowser(this.platformId)) {

      const token: string | null = localStorage.getItem('token');

      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      });

      const httpOptions = { headers };
      return this.http.get(`${this.apiBaseUrl}/api/buyer/Status`, httpOptions).pipe(map(m => <UserData>m))

    } 
    else {
      return of();
    }
  };

  GoLogout(): Observable<Logout> {

    if (isPlatformBrowser(this.platformId)) {

      const token: string | null = localStorage.getItem('token');

      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      });

      const httpOptions = { headers };
      return this.http.get(`${this.apiBaseUrl}/api/buyer/logout`, httpOptions).pipe(map(m => <Logout>m))

    } else {

      return throwError(() => new Error('err'));
    }
  };

  updateProfile(data: any) {
    if (isPlatformBrowser(this.platformId)) {

      const token: string | null = localStorage.getItem('token');

      const headers = new HttpHeaders({
        'Authorization': `Bearer ${token}`
      });

      return this.http.post(`${this.apiBaseUrl}/api/buyer/updateProfile`, data, { headers })

    } else {
      return throwError(() => new Error('err'));
    }
  }

  updateBuyerProfile(data: any) {
    if (isPlatformBrowser(this.platformId)) {

      const token: string | null = localStorage.getItem('token');

      const headers = new HttpHeaders({
        'Authorization': `Bearer ${token}`
      });

      return this.http.post(`${this.apiBaseUrl}/api/buyer/updateBuyerProfile`, data, { headers })

    } else {
      return throwError(() => new Error('err'));
    }
  }

  DeleteLogo(data: any) {
    if (isPlatformBrowser(this.platformId)) {

      const token: string | null = localStorage.getItem('token');

      const headers = new HttpHeaders({
        'Authorization': `Bearer ${token}`
      });

      return this.http.post(`${this.apiBaseUrl}/api/buyer/deleteLogos`, data, { headers })

    } else {
      return throwError(() => new Error('err'));
    }
  }
}
